import { merge } from 'lodash-es'
/**
 * Loops over each item in the arr2 (incoming array).
  If an item with the same id is found in arr1, it merges the two items. If the id does not exist in arr1, it keeps the item from arr2.
  Note that this mutates objects in arr1.
  Also if an item does not exist in arr2, it will be removed from the resulting array.
 * @param oldArr
 * @param newArr
 * @param identifier
 * @returns merged array
 */
export function mergeArrays<T, ID =any> (oldArr: T[], newArr: T[], identifier: (obj: T) => ID): T[] {
  return newArr.map(arr2item => {
    const arr1item = oldArr.find(i => {
      const oldId = identifier(i)
      const newId = identifier(arr2item)
      return oldId != null && oldId === newId
    })
    return arr1item != null ? merge(arr1item, arr2item) : arr2item
  })
}
